import _ from 'lodash'

import { form2fhir } from '../Date/Format/index.js'

import { transform } from './mapper.js'

export function mapFormToApi (formData) {
  const nestedToFlat = obj => {
    const flattened = {
      ...obj,
      name: obj.coding && obj.coding.display,
      code: obj.coding && obj.coding.code,
      system: obj.coding && obj.coding.system,
      coding: null
    }
    return _.omitBy(flattened, _.isNil)
  }

  return formData.map(item => nestedToFlat(item))
}

export function mapApiToForm (response) {
  const flatToNested = obj => {
    const nested = {
      ...obj,
      coding: {
        display: obj.name,
        code: obj.code,
        system: obj.system
      },
      name: null,
      code: null,
      system: null
    }
    return _.omitBy(nested, _.isNil)
  }
  return response.map(item => flatToNested(item))
}

const prescriberEx = {
  url: 'http://narushealth.com/fhir/med-prescriber'
}

const discussedWithPatientExtension = {
  url: 'http://compassion.narushealth.com/fhir/StructureDefinition/discussedWithPatient'
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'MedicationStatement'
  },
  {
    fhir: [ 'contained', { resourceType: 'QuestionnaireResponse' }, 'status' ],
    fhir_const: 'in-progress'
  },
  {
    fhir: [ 'status' ],
    form: [ 'status' ]
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  // RxNorm Medication Coding
  {
    fhir: [ 'medicationCodeableConcept', 'text' ],
    form: [ 'coding', 'display' ]
  },
  {
    fhir: [ 'medicationCodeableConcept', 'coding', 0, 'code' ],
    form: [ 'coding', 'code' ]
  },
  {
    fhir: [ 'medicationCodeableConcept', 'coding', 0, 'display' ],
    form: [ 'coding', 'display' ]
  },
  {
    fhir: [ 'medicationCodeableConcept', 'coding', 0, 'system' ],
    fhir_const: 'http://www.nlm.nih.gov/research/umls/rxnorm'
  },
  // SNOMED Units
  {
    fhir: [ 'dosage', 0, 'doseQuantity', 'unit' ],
    form: [ 'unit', 'display' ]
  },
  {
    fhir: [ 'dosage', 0, 'doseQuantity', 'code' ],
    form: [ 'unit', 'code' ]
  },
  {
    fhir: [ 'dosage', 0, 'doseQuantity', 'system' ],
    form: [ 'unit', 'system' ]
  },
  // SNOMED Routes
  {
    fhir: [ 'dosage', 0, 'route', 'text' ],
    form: [ 'route', 'display' ]
  },
  {
    fhir: [ 'dosage', 0, 'route', 'coding', 0, 'display' ],
    form: [ 'route', 'display' ]
  },
  {
    fhir: [ 'dosage', 0, 'route', 'coding', 0, 'code' ],
    form: [ 'route', 'code' ]
  },
  {
    fhir: [ 'dosage', 0, 'route', 'coding', 0, 'system' ],
    form: [ 'route', 'system' ]
  },
  // Frequency
  {
    fhir: [ 'dosage', 0, 'timing', 'code', 'coding', 0, 'code' ],
    form: [ 'frequency' ]
  },
  {
    fhir: [ 'dosage', 0, 'asNeededBoolean' ],
    form: [ 'prn' ]
  },
  {
    fhir: [ 'dosage', 0, 'additionalInstructions', 0, 'text' ],
    form: [ 'atc' ],
    to_fhir: x => (x ? 'Around the clock' : null),
    to_form: x => x === 'Around the clock'
  },
  // Amt
  {
    fhir: [ 'dosage', 0, 'doseQuantity', 'value' ],
    form: [ 'dose' ]
  },
  // Other
  {
    fhir: [ 'effectivePeriod', 'start' ],
    form: [ 'start' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'effectivePeriod', 'end' ],
    form: [ 'stop' ],
    to_fhir: form2fhir
  },
  {
    fhir: [ 'note', 0, 'text' ],
    form: [ 'comments' ]
  },
  {
    fhir: [ 'reasonForUseCode', 0, 'text' ],
    form: [ 'indication' ]
  },
  {
    fhir: [ 'extension', prescriberEx, 'valueReference', 'reference' ],
    form: [ 'prescriber', 'reference' ]
  },
  {
    fhir: [ 'extension', prescriberEx, 'valueReference', 'display' ],
    form: [ 'prescriber', 'display' ]
  },
  {
    fhir: [ 'extension', discussedWithPatientExtension, 'valueBoolean' ],
    form: [ 'discussedWithPatient' ]
  }
]

export function toFHIR (data, ptId) {
  const res = transform(data, mapping, [ 'form', 'fhir' ])
  const ptRef = { reference: `Patient/${ptId}` }
  res.patient = ptRef
  res.informationSource = ptRef
  return res
}

export function fromFHIR (data) {
  return transform(data, mapping, [ 'fhir', 'form' ])
}
